/*=========================================================================================
	File Name: moduleAuthMutations.js
	Description: Auth Module Mutations
	----------------------------------------------------------------------------------------
	Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
	Author: Pixinvent
	Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from '../../http/axios/index.js'
import state2 from "../state"
export default {
	USINGDEPOT_LIST(state, value) {
		state.UsingDepot = value;
	},
	DEPOTALLOW_LIST(state, value) {
		state.DepotAllow = value;
	},
	STOREHOUSE_LIST(state, value) {
		state.Storehouse = value;
	},
	STOREHOUSE_COMPANY_LIST(state, value) {
		state.StorehouseForCompany = value;
	},
	STOREHOUSEDETAIL_LIST_FOR_STOREHOUSE(state, value) {
		state.StorehouseDetailsForStorehouse = value;
	}, CUSTOMER_INFO_LIST_FOR_CUSTOMER(state, value) {
		state.StorehouseForDepot = value;
	},
	ADD_ITEM_STOREHOUSE(state, item) {
		const output = Object.entries(item).map(([key, value]) => [
			key[0].toUpperCase() + key.slice(1), value,]);
		if (state2.AppActiveUser.ROLE == "Company") state.StorehouseForCompany.push(Object.assign({}, Object.fromEntries(output)))
		else state.Storehouse.push(Object.assign({}, Object.fromEntries(output)))
	},
	DELETE_ITEM_STOREHOUSE(state, item) {
		if (state2.AppActiveUser.ROLE == "Company") {
			const index = state.StorehouseForCompany.findIndex(i => i.DepotId === item)
			if (index > -1) { state.StorehouseForCompany.splice(index, 1) }
		} else {
			const index = state.Storehouse.findIndex(i => i.DepotId === item)
			if (index > -1) { state.Storehouse.splice(index, 1) }
		}
	},
	CARGO_LIST(state, value) {
		state.Cargo = value;
	},

}
